import { render, staticRenderFns } from "./ModalDeleteSnippet.vue?vue&type=template&id=c64536d6&scoped=true"
import script from "./ModalDeleteSnippet.vue?vue&type=script&lang=js"
export * from "./ModalDeleteSnippet.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteSnippet.vue?vue&type=style&index=0&id=c64536d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64536d6",
  null
  
)

export default component.exports